<template>
    <div class="wrapper">

        <!-- Panel principal que muestra -->
        <v-container>
            <!-- Page Content  -->
            <SideBar/>
            <Footer/>
        </v-container>
    </div>


</template>

    <script>
        import SideBar from './SideBar'

        import Footer from './Footer'
        export default {
            components: {
                SideBar,
                Footer
            },
            methods:{
        }   
    }
</script>

<style>



</style>



// WEBPACK FOOTER //
// src/components/template/Layout.vue